import PropTypes from 'prop-types'
import React, {forwardRef} from 'react'

import icons from './icons.svg'

const Icon = ({size, className, name, myRef}) => {
  // eslint-disable-next-line react/display-name
  const FancySvg = forwardRef((_, ref) => (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      className={`icon-svg icon-svg--size-${size} ${className}`}>
      <use xlinkHref={`${icons}#${name}`} />
    </svg>
  ))

  if (myRef) {
    return <FancySvg ref={myRef} />
  }

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      className={`icon-svg icon-svg--size-${size} ${className}`}>
      <use xlinkHref={`${icons}#${name}`} />
    </svg>
  )
}
Icon.displayName = 'Icon'
Icon.propTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
  name: PropTypes.string,
  myRef: PropTypes.string,
}

export default Icon
